
<template>
  <div class="col-xs-12 col-sm-10 default-list-contain-sty" v-if="!this.$parent.isLoadShow">
    <div class="order-title-area-sty">
      <div class="order-main-title-sty">
        <h5>
          <span>
            訂單編號 <b>#{{orderInfo.id}}</b>
          </span>
          <span style="margin-left:25px;">
            <b>{{ orderInfo.service_type }}</b>
          </span>
        </h5>
      </div>
      <hr>
      <div class="row">
        <div class="col-sm-4 order-info-label-sty">服務時間</div>
        <div class="col-sm-8">
          <span class="list-order-date-sty">{{orderInfo.roc_date}} ( {{orderInfo.diplayWeekDay}} )</span>
          <span class="list-order-time-sty">{{orderInfo.time_desc }}</span>
        </div>
      </div>
      <div class="order-info-status-sty">
        <div class="order-info-label-sty">訂單狀態</div>
        <div>
          <span :class="`${ orderInfo.statusClass }`"> {{ orderInfo.status }} </span>
        </div>
      </div>
      <div class="row order-info-group-sty" v-if="orderInfo.staffs">
        <div class="col-sm-4 order-info-label-sty">服務夥伴</div>
        <div class="col-sm-8">
          <div v-for="(staff, index) in orderInfo.staffs" :key="index">
            <b v-on:click="goToAccountPage('staff', staff.id)" v-if="userType === 'customer'"> {{staff.displayN}}</b>
            <b v-else> {{staff.displayN}}</b>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="order-contain">
      <div class="">
        <div class="order-sub-title-sty">
          <h5 v-if="userType === 'customer'">個人資料</h5>
          <h5 v-else>服務對象資料</h5>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">姓名</div>
          <div class="col-sm-8" v-if="userType === 'customer'">{{ orderInfo.name }}</div>
          <div class="col-sm-8" v-on:click="goToAccountPage('customer', orderInfo.user_id)" v-else >{{ orderInfo.name }}</div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">手機</div>
          <div class="col-sm-8">{{ orderInfo.phone }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.alternate_phone && orderInfo.alternate_phone.length > 0">
          <div class="col-sm-4 order-info-label-sty">備用電話</div>
          <div class="col-sm-8">{{ orderInfo.alternate_phone }}</div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">地址<span @click="copyAddress" class="rs-icon-btn-sty rs-icon-color-ligtorange"><i class="rs-icon-default rs-icon-address"></i></span></div>
          <div class="col-sm-8">{{ orderInfo.location }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.contactDsTime && orderInfo.contactDsTime.length > 0">
          <div class="col-sm-12 order-info-label-sty" v-if="userType === 'customer'">您方便接聽電話的時段</div>
          <div class="col-sm-12 order-info-label-sty" v-else>客戶方便接聽電話的時段</div>
          <div class="col-sm-12"  v-for="(time, index) in orderInfo.contactDsTime" :key="index">
            <div>
              時段{{ index + 1 }}: <b style="color: #6086ed;">{{ time }}</b>
            </div>
          </div>
        </div>
        <div class="order-sub-title-sty">
          <h5>清潔相關資訊</h5>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">服務類型</div>
          <div class="col-sm-8">{{ orderInfo.service_type }}</div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">清潔建築類型</div>
          <div class="col-sm-8">{{ orderInfo.building_type }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.cleaning_range && orderInfo.cleaning_range.length > 0">
          <div class="col-sm-4 order-info-label-sty">清潔範圍</div>
          <div class="col-sm-8 rc-html-sty">{{ orderInfo.cleaning_range }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.building_square && orderInfo.building_square.length > 0">
          <div class="col-sm-4 order-info-label-sty">清潔範圍大小</div>
          <div class="col-sm-8">{{ orderInfo.building_square }}</div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">服務員性別指定</div>
          <div class="col-sm-8">{{ orderInfo.gender }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.has_pet || orderInfo.spec_clenaer || orderInfo.spec_glue_rm">
          <div class="col-sm-12 order-info-label-sty">清潔注意項目</div>
          <div class="col-sm-4" v-if="orderInfo.has_pet">
            <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
            <span class="textafterimg-sty">有寵物</span>
          </div>
          <div class="col-sm-4" v-if="orderInfo.spec_clenaer">
            <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
            <span class="textafterimg-sty">自備吸塵器</span>
          </div>
          <div class="col-sm-4" v-if="orderInfo.spec_glue_rm">
            <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
            <span class="textafterimg-sty">除膠</span>
          </div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.note && orderInfo.note.length > 0">
          <div class="col-sm-12 order-info-label-sty">訂單注意事項</div>
          <div class="col-sm-12 rc-html-sty">{{ orderInfo.note }}</div>
        </div>
      </div>
      <div v-if="houseCheckInfo.id || isStartCheck">
        <hr>
        <HouseCheckList v-if="isStartCheck" :userTransferplanCash="userTransferplanCash" :houseCheckInfo="houseCheckInfo" :orderCounts="orderInfo.user_order_ok_count" :actionType="houseAction" :freeHourTotal="freeHourTotal" ref="housecheckform"></HouseCheckList>
        <div v-else>
          <div class="order-sub-title-sty">
            <h5>環境空間確認</h5>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-12 order-info-label-sty">需要清掃房間</div>
            <div class="col-sm-12" v-if="!houseCheckInfo.kitchen && !houseCheckInfo.living_room && !houseCheckInfo.bedroom && !houseCheckInfo.bathroom && !houseCheckInfo.balcony && !houseCheckInfo.entrance">
              <span>未確認環境空間</span>
            </div>
            <div class="col-sm-4" v-if="houseCheckInfo.kitchen">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">廚房</span>
            </div>
            <div class="col-sm-4" v-if="houseCheckInfo.living_room">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">客廳</span>
            </div>
            <div class="col-sm-4" v-if="houseCheckInfo.bedroom">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">臥室</span>
            </div>
            <div class="col-sm-4" v-if="houseCheckInfo.bathroom">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">浴室</span>
            </div>
            <div class="col-sm-4" v-if="houseCheckInfo.balcony">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">陽台</span>
            </div>
            <div class="col-sm-4" v-if="houseCheckInfo.entrance">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">玄關</span>
            </div>
          </div>
          <div class="row order-info-group-sty" v-if="houseCheckInfo.note && houseCheckInfo.note.length > 0">
            <div class="col-sm-12 order-info-label-sty">環境注意事項</div>
            <div class="col-sm-12">{{ houseCheckInfo.note }}</div>
          </div>
        </div>
      </div>
      <hr>
      <div v-if="!isStartCheck">
        <div class="order-sub-title-sty">
          <h5>方案資訊</h5>
        </div>
        <div class="row order-info-group-sty" v-if="userType === 'staff' && userTypeStr">
          <div class="col-sm-4 order-info-label-sty">類型</div>
          <div class="col-sm-8">{{ userTypeStr }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="userType === 'customer' && (houseCheckInfo.user_type === 2 || houseCheckInfo.user_type === 3) && userTypeStr">
          <div class="col-sm-4 order-info-label-sty">類型</div>
          <div class="col-sm-8" style="color: red;">{{ userTypeStr }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="userType === 'staff' && orderTypeStr">
          <div class="col-sm-4 order-info-label-sty">特殊方案</div>
          <div class="col-sm-8">{{ orderTypeStr }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="userType === 'customer' && (houseCheckInfo.order_type === 2 || houseCheckInfo.order_type === 3)">
          <div class="col-sm-4 order-info-label-sty">特殊方案</div>
          <div class="col-sm-8">{{ orderTypeStr }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.coupon_code_cost && orderInfo.coupon_code">
          <div class="col-sm-4 order-info-label-sty">折扣碼</div>
          <div class="col-sm-8">{{ orderInfo.coupon_code }}</div>
          <div class="col-sm-4 order-info-label-sty">折扣金額</div>
          <div class="col-sm-8 order-status-warn">{{ orderInfo.coupon_code_cost }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.specified_cash">
          <div class="col-sm-4 order-info-label-sty">預算上限金額</div>
          <div class="col-sm-8">{{ orderInfo.specified_cash }} 元</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.specified_max_cash_time">
          <div class="col-sm-4 order-info-label-sty">預算上限時數</div>
          <div class="col-sm-8">{{ orderInfo.specified_max_cash_time }} 小時</div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">付款方式</div>
          <div class="col-sm-8">{{ orderInfo.payment }}</div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.transfer_code">
          <div class="col-sm-4 order-info-label-sty">付款帳號後五碼</div>
          <div class="col-sm-8">{{ orderInfo.transfer_code }}</div>
        </div>
      </div>
      <div v-if="orderInfo.status_code === 6 || orderInfo.status_code === 7">
        <div class="order-sub-title-sty">
          <h5>當前花費時間與金額</h5>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">花費時間</div>
          <div class="col-sm-8">
            <span>{{ orderInfo.cost_time }}</span>
          </div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.coupon_code">
          <div class="col-sm-4 order-info-label-sty">使用折扣碼</div>
          <div class="col-sm-8">
            <span>{{ orderInfo.coupon_code }}</span>
          </div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.coupon_code_cost">
          <div class="col-sm-4 order-info-label-sty">折扣金額</div>
          <div class="col-sm-8">
            <span>{{ orderInfo.coupon_code_cost }}</span>
          </div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">目前金額</div>
          <div class="col-sm-8">
            <span>{{ orderInfo.cash }}</span>
          </div>
        </div>
      </div>
      <div v-if="orderInfo.status_code === 7 && orderInfo.score_item_infos.length > 0">
        <div class="order-sub-title-sty">
          <h5>訂單評分</h5>
        </div>
        <div v-for="(scoption, index) in orderInfo.score_item_infos" :key="index">
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">{{ scoption.label }}</div>
            <div class="col-sm-8">
              <b-form-rating :id="'score_val_' + index" v-model="scoption.score" inline readonly no-border size="md" class="re-order-input-sty"></b-form-rating>
            </div>
            <div class="col-sm-12" v-if="scoption.feedback">{{ scoption.feedback }}</div>
          </div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-4 order-info-label-sty">平均分數</div>
          <div class="col-sm-8">
            <span>{{ orderInfo.score }}</span>
          </div>
        </div>
        <div class="row order-info-group-sty" v-if="orderInfo.score_feedback">
          <div class="col-sm-4 order-info-label-sty">用戶回饋</div>
          <div class="col-sm-8">
            <span>{{ orderInfo.score_feedback }}</span>
          </div>
        </div>
      </div>
      <hr>
      <div class="order-footer-contain text-left" v-if="!isPayMent">
        <b-button
            class="text-white order-info-btn-sty "
            variant="info"
            size="md"
            @click="beckToList"
            v-if="!isStartCheck"
            >返回列表
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="primary"
            size="md"
            @click="startHouseCheck"
            v-if="userType === 'staff' && (!houseCheckInfo.id) && orderInfo.status_code === 2 && !isStartCheck">
            開始環境確認
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="primary"
            size="md"
            @click="startHouseCheck"
            v-if="userType === 'staff' && houseCheckInfo.id && (orderInfo.status_code === 2 || orderInfo.status_code === 3) && !isStartCheck">
            修改環境確認
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="success"
            size="md"
            @click="startClean"
            v-if="userType === 'staff' && orderInfo.status_code === 3">
            開始清潔
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="danger"
            size="md"
            @click="handleCleanStatus"
            v-if="userType === 'staff' && orderInfo.status_code === 4">
            暫停清潔
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="success"
            size="md"
            @click="handleCleanStatus"
            v-if="userType === 'staff' && orderInfo.status_code === 5">
            繼續清潔
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="warning"
            size="md"
            @click="checkOutOrder"
            v-if="userType === 'staff' && (orderInfo.status_code === 4 || orderInfo.status_code === 5)">
            完成清掃
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="primary"
            size="md"
            @click="finishClean"
            v-if="orderInfo.status_code === 6 && houseCheckInfo.payment === 1">
            確認金額
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="primary"
            size="md"
            @click="goPayMent"
            v-if="userType === 'customer' && orderInfo.status_code === 6 && houseCheckInfo.payment === 2 && !orderInfo.transfer_code">
            已完成匯款
        </b-button>
        <b-button
          class="text-white order-info-btn-sty"
          variant="success"
          size="md"
          @click="submitHouseForm"
          :disabled="
            (houseCheckInfo.kitchen || houseCheckInfo.living_room || houseCheckInfo.bedroom || houseCheckInfo.bathroom || houseCheckInfo.balcony || houseCheckInfo.entrance) ? false : true"
          v-if="userType === 'staff' && isStartCheck">送出
        </b-button>
        <b-button
            class="text-white order-info-btn-sty"
            variant="success"
            size="md"
            @click="goToScore"
            v-if="userType === 'customer' && orderInfo.status_code === 7 && orderInfo.score_item_infos.length === 0">
            評價清潔
        </b-button>
        <!-- <b-button
            class="text-white order-info-btn-sty"
            variant="success"
            size="md"
            @click="goToAddRecord"
            v-if="userType === 'staff' && orderInfo.status_code === 7">
            填寫服務履歷
        </b-button> -->
        <b-button
          class="text-white"
          variant="secondary"
          size="md"
          @click="cancelHouseFrom"
          v-if="userType === 'staff' && isStartCheck">取消
        </b-button>
        <!-- <b-button
          class="text-white"
          variant="secondary"
          size="md"
          @click="checkCancelFrom"
          v-if="userType === 'customer'">取消訂單
        </b-button> -->
      </div>
      <div class="order-footer-contain text-left" v-else>
        <b-form-group
          label="請輸入匯款帳戶後5碼:"
          label-for="edit-address"
        >
          <input type="number" class="form-control re-order-input-sty" id="transfer_code" name="transfer_code" v-model="transfer_code" placeholder="您的帳戶後五碼">
          <!-- <b-form-input
            id="transfer_code"
            type="number"
            v-model="transfer_code"
          ></b-form-input> -->
        </b-form-group>
        <b-button
          class="text-white order-info-btn-sty"
          variant="success"
          size="md"
          @click="checkOrderTransfer"
        >送出
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import HouseCheckList from './staff/HouseCheckList.vue'
export default {
  name: 'CurrentOrder',
  props: {
    userId: String,
    userType: String,
    orderId: String
  },
  created () {
    this.$nextTick(() => {
      this.getOrderInfo()
    })
  },
  data () {
    return {
      baseUrl: '',
      orderInfo: {},
      houseCheckInfo: {
        id: '',
        kitchen: false,
        living_room: false,
        bedroom: false,
        bathroom: false,
        balcony: false,
        entrance: false,
        note: '',
        force_price: 9,
        payment: null,
        order_type: 1,
        user_type: 1 // 1. normal , 2. vip
        // user_order_ok_count: 0
      },
      orderTypeStr: null, // free, 首次
      userTypeStr: null, // normal, vip
      transfer_code: null,
      isStartCheck: false,
      isPayMent: false,
      houseAction: 'create',
      userTransferplanCash: 0
    }
  },
  watch: {
    transfer_code (value) {
      var valArr = []
      var finalVal
      if (value) {
        valArr = String(value).split('')
        if (valArr.length > 5) {
          valArr.splice(5)
          finalVal = parseInt(valArr.join(''))
          console.log(finalVal)
          this.transfer_code = finalVal
        }
      }
    },
    'houseCheckInfo.user_type' (val) {
      if (val) {
        this.userTypeStr = this.$toolDoc.convertOrderUserType(val)
      }
    },
    'houseCheckInfo.order_type' (val) {
      if (val) {
        this.orderTypeStr = this.$toolDoc.convertOrderType(val)
      }
    }
  },
  methods: {
    getOrderInfo () {
      const self = this
      this.baseUrl = this.$props.userType !== 'staff' ? this.$apiDoc.customerUrl : this.$apiDoc.staffUrl
      const getUrl = this.baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$parent.isLoadShow = true
      this.$api.get(getUrl, {}).then((resp) => {
        if (resp.result) {
          self.orderInfo = self.$toolDoc.arrangeOrderData(resp.data)
          if (self.$props.userType === 'staff') {
            self.getCustomerInfo()
          }
          if (self.orderInfo.status_code !== 1) {
            self.getHouseCheckInfo()
          } else {
            self.$parent.isLoadShow = false
          }
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
          self.$parent.isLoadShow = false
        }
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        alert(errorMsg)
        self.$parent.isLoadShow = false
      })
    },
    getHouseCheckInfo () {
      const self = this
      this.baseUrl = this.$props.userType !== 'staff' ? this.$apiDoc.customerUrl : this.$apiDoc.staffUrl
      var getUrl = this.baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiGetHouseCheck
      if (this.$props.userType === 'staff') {
        getUrl += '/' + this.$apiDoc.apiActionEdit
      }
      this.$api.get(getUrl, {}).then((resp) => {
        if (resp.result) {
          self.houseCheckInfo = this.arrangeHouseCheckInfo(resp.data)
        }
        self.$parent.isLoadShow = false
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        self.$parent.isLoadShow = false
      })
    },
    getCustomerInfo () {
      // also get order maximum info
      var self = this
      const getUrl = this.baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiGetHouseCheck + '/' + this.$apiDoc.apiActionNew
      this.$api.get(getUrl, {}).then((resp) => {
        if (resp.result) {
          if (resp.data) {
            self.combineCustomerInfo(true, resp.data)
          }
        }
        self.$parent.isLoadShow = false
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        self.$parent.isLoadShow = false
      })
    },
    combineCustomerInfo (isOrderInfo, data) {
      if (data) {
        if (isOrderInfo) {
          if (data.force_price) {
            this.houseCheckInfo.force_price = data.force_price
          }
          this.orderInfo.user_type = (data.user_type !== undefined) ? data.user_type : 1
          this.orderInfo.user_order_ok_count = (data.user_order_ok_count !== undefined) ? data.user_order_ok_count : 0
          this.freeHourTotal = (data.user_free_hour_total !== undefined) ? data.user_free_hour_total : 0
          this.userTransferplanCash = data.user_total_top_up_cash + data.user_unactive_top_up_total_cash
          if (data.order !== null && data.order !== undefined) {
            this.orderInfo.user_type = data.order.user_type
            this.orderInfo.order_type = data.order.order_type
            this.houseCheckInfo.user_type = data.order.user_type
            this.houseCheckInfo.order_type = data.order.order_type
          } else {
            this.houseCheckInfo.user_type = this.orderInfo.user_type
          }
          if (data.specified_max_cash_time) {
            this.houseCheckInfo.specified_max_cash_time = data.specified_max_cash_time
          }
          if (data.specified_cash) {
            this.houseCheckInfo.specified_cash = data.specified_cash
          }
        } else {
          if (data.user_type === undefined) {
            if (data.user_info !== undefined) {
              data.user_type = data.user_info.user_type
              this.freeHourTotal = (data.user_info.user_free_hour_total !== undefined) ? data.user_info.user_free_hour_total : 0
            } else {
              data.user_type = (this.orderInfo.user_type !== undefined) ? this.orderInfo.user_type : 1
            }
          }
          if (data.user_info !== undefined) {
            this.orderInfo.user_order_ok_count = data.user_info.user_order_ok_count
          }
          if (data.order_type === undefined) {
            data.order_type = (data.user_order_ok_count === 0 || this.freeHourTotal > 0) ? 3 : 1
          }
          this.orderTypeStr = this.$toolDoc.convertOrderType(data.order_type)
          this.userTypeStr = this.$toolDoc.convertOrderUserType(data.user_type)
        }
      }
    },
    startHouseCheck () {
      if (this.houseCheckInfo.id) {
        this.houseAction = 'edit'
        if (this.orderInfo.specified_max_cash_time) {
          this.houseCheckInfo.specified_max_cash_time = this.orderInfo.specified_max_cash_time
        }
        if (this.orderInfo.specified_cash) {
          this.houseCheckInfo.specified_cash = this.orderInfo.specified_cash
        }
      } else {
        this.houseAction = 'create'
      }
      this.isStartCheck = true
    },
    submitHouseForm () {
      const self = this
      try {
        self.$refs.housecheckform.submitHouseForm()
      } catch (e) {
        self.setDebugInfo('SubmitHouse', e, true)
      }
    },
    cancelHouseFrom () {
      this.isStartCheck = false
    },
    checkCancelFrom () {},
    beckToList () {
      var routePt = '/' + this.$props.userType + this.$apiDoc.routerOrderList
      this.$router.push({ path: routePt, replace: true })
      // this.$router.go()
      location.reload()
    },
    startClean () {
      const self = this
      const getUrl = this.baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiOrderStart
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$parent.isLoadShow = true
      this.$api.post(getUrl).then((resp) => {
        if (resp.result) {
          self.getOrderInfo()
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
          self.$parent.isLoadShow = false
        }
      }).catch((e) => {
        console.warn('action:', e)
        alert(errorMsg)
        self.$parent.isLoadShow = false
      })
    },
    handleCleanStatus () {
      const self = this
      const getUrl = this.baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId
      var actionUrl
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$parent.isLoadShow = true
      switch (this.orderInfo.status_code) {
        case 4:
          actionUrl = this.$apiDoc.apiOrderPause
          break
        case 5:
          actionUrl = this.$apiDoc.apiOrderResume
          break
      }
      this.$api.post(getUrl + actionUrl).then((resp) => {
        if (resp.result) {
          self.getOrderInfo()
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
          self.$parent.isLoadShow = false
        }
      }).catch((e) => {
        console.warn('action:', e)
        alert(errorMsg)
      })
    },
    finishClean () {
      const self = this
      const getUrl = this.baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiOrderComplete
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$parent.isLoadShow = true
      this.$api.post(getUrl).then((resp) => {
        if (resp.result) {
          self.getOrderInfo()
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
          self.$parent.isLoadShow = false
        }
      }).catch((e) => {
        console.warn('action:', e)
        alert(errorMsg)
        self.$parent.isLoadShow = false
      })
    },
    checkOutOrder () {
      const self = this
      const getUrl = this.baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiOrderCheckout
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$parent.isLoadShow = true
      this.$api.post(getUrl).then((resp) => {
        if (resp.result) {
          self.getOrderInfo()
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
          self.$parent.isLoadShow = false
        }
      }).catch((e) => {
        console.warn('action:', e)
        alert(errorMsg)
        self.$parent.isLoadShow = false
      })
    },
    arrangeHouseCheckInfo (obj) {
      if (obj) {
        if (this.orderInfo.force_price) {
          obj.force_price = this.orderInfo.force_price
        }
        if (!obj.payment && this.orderInfo.payment) {
          switch (this.orderInfo.payment) {
            case 3:
              obj.payment = 3
              break
            case 2:
            case '匯款':
              obj.payment = 2
              break
            default:
              obj.payment = 1
          }
        }
        this.combineCustomerInfo(false, obj)
      }
      return obj
    },
    goPayMent () {
      this.isPayMent = true
    },
    checkOrderTransfer () {
      var valArr = []
      var isError = true
      if (this.transfer_code) {
        valArr = String(this.transfer_code).split('')
        if (valArr.length === 5) {
          isError = false
        }
      }
      if (isError) {
        alert('請完整輸入您帳戶的後五碼，謝謝')
      } else {
        this.submitTransfer()
      }
    },
    submitTransfer () {
      const self = this
      var finalUrl = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiPostTransfer
      var options = {
        transfer_code: String(this.transfer_code)
      }
      var errorMsg
      this.$parent.isLoadShow = true
      this.$api.post(finalUrl, options).then((resp) => {
        self.isPayMent = false
        if (resp.result) {
          self.getOrderInfo()
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
        }
        self.$parent.isLoadShow = false
        this.$liff.closeWindow()
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        self.$parent.isLoadShow = false
        this.$liff.closeWindow()
      })
    },
    setDebugInfo (type, val, ispop) {
      // const self = this
      const setLogApi = this.$apiDoc.apiSetLog
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var option = {}
      var logMsg = '[Debug][Reception]'
      if (type) {
        logMsg += '[' + type + '][' + this.userType + '][errorInfo]: '
      }
      logMsg += JSON.stringify({ message: val.message, stack: val.stack })
      option.err = logMsg
      option.line_user_id = this.userId
      this.$api.post(setLogApi, option).then((resp) => {
        if (resp.result) {
          if (ispop) {
            alert(errorMsg)
          }
        }
      }).catch((errorInfo) => {
        errorMsg += '[errorInfo]:' + JSON.stringify(errorInfo)
        if (ispop) {
          alert(errorMsg)
        } else {
          console.log(errorMsg)
        }
      })
    },
    goToScore () {
      const pt = '/' + this.$props.userType + this.$apiDoc.routerOrderScore + '#' + this.orderId
      this.$router.push({ path: pt, replace: true })
      location.reload()
    },
    goToAccountPage (accountType, id) {
      var routePt = '/' + this.$props.userType + this.$apiDoc.routerAccount
      if (accountType && accountType !== 'staff') {
        routePt += accountType
        if (id !== undefined && id !== null) {
          routePt += '#' + id
          this.$router.push({ path: routePt, replace: true })
          location.reload()
        }
      }
    },
    goToAddRecord () {
      var recordInfo = {
        step: 1,
        orderId: this.orderId
      }
      var idString = this.$tool.encodeString(JSON.stringify(recordInfo))
      var pt = '/' + this.$props.userType + this.$apiDoc.routerOrderAddRecord
      if (idString) {
        pt += '#' + idString
        this.$router.push({ path: pt, replace: true })
        location.reload()
      }
    },
    copyAddress () {
      const self = this
      if (this.orderInfo && this.orderInfo.location) {
        navigator.clipboard.writeText(this.orderInfo.location).then(() => {
          self.$bvToast.toast('成功複製地址', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'success',
            solid: true
          })
        })
      }
    }
  },
  components: {
    HouseCheckList
  }
}
</script>
